
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
// import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryListProvider } from "../../../component/solution/QueryTableList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";
import { QueryTableList } from "../../../component/solution/QueryTableList/QueryTableList";
import { formatDateFull } from "../../../component/solution/utils/AppUtil";

export const PurchaseOrder: React.FC = () => {

    return(
        <React.Fragment>
            {/* <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryList
                        listTitle={"Purchase Orders"}
                        recordTitle={"Purchase Order"}
                        tableName={"sa_purchase_order"}
                        editTableName={"sa_purchase_invoice"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "po_number",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "supplier_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "erp_invoice",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "reference",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "order_date",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "fixably_id",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "erp_updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            }
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                            {
                                fullColumnName: "created",
                                direction: "DESC",
                                cast: CastType.STRING
                            }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>
            </Container> */}

            <Container fluid className="p-0">
              <QueryListProvider>
                <QueryTableList
                    listTitle={"Purchase Orders"}
                    recordTitle={"Purchase Orders"}
                    tableName={""}
                    editTableName={""}
                    hasIntegrationStatusLegend={false} 
                    errorCategoryName={''}
                    editHasCompoundKey={false}   
                    showFailedTransactionsTable={false}
                    query={{
                        appCode: null,
                        selectCode: null,
                        tableName: "sa_purchase_order",
                        where: "",
                        orderBy: 'created ASC',
                        pageNum: 0,
                        pageSize: 100,
                        params: {},
                    }} 
                    orderColumns={[
                            { name: "po_number", type: "STRING", sortable: true, searchable: true },
                            { name: "supplier_code", type: "STRING", sortable: true, searchable: true },
                            { name: "erp_invoice", type: "STRING", sortable: true, searchable: true },
                            { name: "reference", type: "STRING", sortable: true, searchable: true },
                            { name: "order_date", type: "TIMESTAMP", sortable: true, searchable: false },
                            { name: "fixably_id", type: "INTEGER", sortable: true, searchable: true },
                            { name: "fixably_updated", type: "BOOLEAN", sortable: true, searchable: true },
                            { name: "created", type: "TIMESTAMP", sortable: true, searchable: true },
                            { name: "updated", type: "TIMESTAMP", sortable: true, searchable: true }
                    ]}
                    renderRowData={(row) => {
                                            
                        const tdStyle: React.CSSProperties = { whiteSpace: 'nowrap', border: '1px solid #deebed',  padding: '4px 8px', fontSize: '0.75rem' };
                        const tdEllipsis: React.CSSProperties = {...tdStyle, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'};
                    
                        return (
                            <>
                                <td style={tdStyle} title={row.po_number}>{row.po_number}</td>
                                <td style={tdStyle} title={row.supplier_code}>{row.supplier_code}</td>
                                <td style={tdStyle} title={row.erp_invoice}>{row.erp_invoice}</td>
                                <td style={tdStyle} title={row.reference}>{row.reference}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.order_date))}>{formatDateFull(String(row.order_date))}</td>
                                <td style={tdStyle} title={row.fixably_id}>{row.fixably_id}</td>
                                <td style={tdStyle} title={row.fixably_updated}>{row.fixably_updated}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.created))}>{formatDateFull(String(row.created))}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.updated))}>{formatDateFull(String(row.updated))}</td>
                            </>    
                        );
                    }}   
                    renderActions={(row) => {
                            return (
                                <td className="sa-record-control" style={{ border: '1px solid #deebed', height: '45px', fontSize: '0.55rem', padding: '0 5px'}}>
                    
                                </td>
                            );
                    }}                      
                />
             </QueryListProvider>
           </Container> 
        </React.Fragment>
    );
}